module.exports = "{{errorMessage}}"


//////////////////
// WEBPACK FOOTER
// ./src/app/error-message/error-message.component.html
// module id = ./src/app/error-message/error-message.component.html
// module chunks = main